<template>
  <!--  <p class="g-title">{{ title }}</p>-->
  <div class="title-cont">
    <div class="text">{{ title }}</div>
    <div class="hr-l"></div>
    <!--    <div class="hr-s"></div>-->
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    title: null,
    isShowLine: Boolean,
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.title-cont {
  display: flex;
  flex-direction: column;
  align-items: center;
  .text {
    padding: 20px 15px 20px 15px;
    max-width: 100%;
    box-sizing: border-box;
    font-family: Microsoft YaHei UI Light;
    font-size: 30px;
    font-weight: bolder;
    color: #333;
    text-align: center;
    line-height: 76px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    position: relative;
  }
  .hr-s {
    height: 1px;
    width: 30px;
    background: #adb3c7;
    position: relative;
    bottom: 35px;
    margin: 0 auto;
  }

  .hr-l {
    height: 1px;
    width: 110px;
    background: #e5e5e5;
    position: relative;
    bottom: 33px;
    margin: 0 auto;
  }
  .hr-l:before {
    content: "";
    display: block;
    height: 1px;
    width: 30%;
    margin-left: calc(70% / 2);
    margin-top: -1px;
    background: #adb3c7;
  }
}
</style>
